// extracted by mini-css-extract-plugin
export default {"offers":"styles_offers__TdoEb","header":"styles_header__1sKDg","title":"styles_title__5LlXb","subtitle":"styles_subtitle__xepNa","sectionShell":"styles_sectionShell__Gw4sG"};